import app from './../index';

export default class RechnungController {

  constructor($routeParams, $uibModal) {
    this.dateOptions = {
      formatYear: 'yy',
      startingDay: 1
    };

    this.rechnungId = $routeParams.id;
    this.modal = $uibModal;
    this.serviceBase = app.serviceBase;

    this.refresh();
  }

  refresh() {
    this.rechnung = app.api.rechnungen.get({ id: this.rechnungId });
  }

  rechnungStornieren() {
    this.rechnung.$stornieren();
  }

  bezahlen() {
    var zahlungsInfo = {
      datum: new Date(),
      skonto: 0.0
    };

    var rechnung = this.rechnung;

    var modalInstance = this.modal.open({
      templateUrl: 'rechnungen/dialogRechnungBezahlen.html',
      size: 'md',
      resolve: {
        zahlungsInfo: function () {
          return zahlungsInfo;
        }
      },
      controller: function ($scope, $uibModalInstance, zahlungsInfo) {

        $scope.zahlungsInfo = zahlungsInfo;

        $scope.ok = function () {
          $uibModalInstance.close();
        };

        $scope.cancel = function () {
          $uibModalInstance.dismiss();
        };
      }
    });

    modalInstance.result
      .then(() => {
        rechnung.$bezahlen(zahlungsInfo);
        window.toastr.info("Rechnung wurde bezahlt");
        this.refresh();
      });
  }
}

RechnungController.$inject = ['$routeParams', '$uibModal'];



// WEBPACK FOOTER //
// ./app/rechnungen/rechnungController.js